"use client";
import Link, { LinkProps } from "next/link";


export type { LinkProps };

const NextLink = Link;
export default NextLink;
